var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "company_email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.793 32.5104H25.293V32.0104V29.0937V28.5937H24.793H17.5013C11.4483 28.5937 6.33464 23.4801 6.33464 17.4271C6.33464 11.3741 11.4483 6.26042 17.5013 6.26042C23.5543 6.26042 28.668 11.3741 28.668 17.4271V19.5125C28.668 19.9423 28.4716 20.3964 28.142 20.7468C27.8126 21.097 27.3906 21.3021 26.9805 21.3021C26.5703 21.3021 26.1483 21.097 25.8189 20.7468C25.4894 20.3964 25.293 19.9423 25.293 19.5125V17.4271C25.293 13.1259 21.8024 9.63542 17.5013 9.63542C13.2002 9.63542 9.70963 13.1259 9.70963 17.4271C9.70963 21.7282 13.2002 25.2188 17.5013 25.2188C19.4519 25.2188 21.2503 24.5002 22.6157 23.3062C23.683 24.4837 25.289 25.2188 26.9805 25.2188C30.1424 25.2188 32.5846 22.6485 32.5846 19.5125V17.4271C32.5846 9.10094 25.8274 2.34375 17.5013 2.34375C9.17516 2.34375 2.41797 9.10094 2.41797 17.4271C2.41797 25.7532 9.17516 32.5104 17.5013 32.5104H24.793ZM17.5013 21.3021C15.3566 21.3021 13.6263 19.5718 13.6263 17.4271C13.6263 15.2824 15.3566 13.5521 17.5013 13.5521C19.646 13.5521 21.3763 15.2824 21.3763 17.4271C21.3763 19.5718 19.646 21.3021 17.5013 21.3021Z",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyEmail);
export default __webpack_public_path__ + "static/media/company_email.c2b3a55402c2a3bd573f88c82da09bce.svg";
export { ForwardRef as ReactComponent };